module.exports = __webpack_public_path__ + "fcef6ac3874368d084b8bb6b576f7188.svg";